import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Analytics } from '@vercel/analytics/react'
import { Outlet } from 'react-router-dom'
import '../styles/App.css'
import { Suspense } from 'react'
import { ConfigProvider } from 'antd'
import ContestantScoreContextProvier from '../pages/ContestantList/context/ContestantScoreContext'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
})

export default function RootLayout() {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Pagination: {
                        colorBgContainer: '#010a1a',
                        colorText: '#fff',
                        colorTextDisabled: '#fff',
                        colorTextPlaceholder: '#fff',
                        fontSize: 20,
                        wireframe: true
                    }
                }
            }}
        >
            <QueryClientProvider client={queryClient}>
                <Suspense fallback={<div>Loading...</div>}>
                    <ContestantScoreContextProvier>
                        <Outlet />
                    </ContestantScoreContextProvier>
                </Suspense>
                <Analytics />
            </QueryClientProvider>
        </ConfigProvider>
    )
}
